let Price = function (val) {
  this.value = Price.valueify(val);
};

Price.PRECISION = 100; // the precision of the "invisible" part of a  price (general precision is PRECISION * 100)
Price.create = function (val) {
  return new Price(val);
};
Price.valueify = function (val) {
  if (val && val !== 0) {
    if (typeof (val) === "string") {
      val = val.replace(",", ".");
    }
    return Math.round(parseFloat(val) * 100) * Price.PRECISION;
  }
  return 0;
};
Price.numberify = function (val) {
  return Math.round(val / Price.PRECISION) / 100;
};
Price.normalize = function (val) {
  let ret = Math.round(val / 100) * 100;
  // convert -0 to 0
  if (ret === 0) return 0;
  return ret;
};
Price.absolute = function (val) {
  return Math.abs(val);
};
Price.markify = function (value = this.value) {
  value = Number(value) || 0;
  //fix -0 issue
  if (value > -0.005 && value <= 0) value = 0;
  return new Intl.NumberFormat("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value);
};
Price.stringify = function (val = this.value) {
  val = Number(val) || 0;
  //fix -0 issue
  if (val > -0.005 && val <= 0) val = 0;
  return new Intl.NumberFormat("de-DE", { useGrouping: false, minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(val);
};
Price.formatify = function (val = this.value) {
  val = Number(val) || 0;
  //fix -0 issue
  if (val > -0.005 && val <= 0) val = 0;
  return new Intl.NumberFormat("de-DE", { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(val));
};
Price.formatUnit = function (unit) {
  if (String(unit).toLowerCase() === "eur") return "EUR";
  return String(unit).toUpperCase();
};
Price.prototype.get = function () {
  return this.value;
};
Price.prototype.getPrice = function () {
  return Price.numberify(this.value);
};
Price.prototype.set = function (intval) {
  this.value = intval;
  return this;
};
Price.prototype.setPrice = function (val) {
  this.value = Price.valueify(val);
  return this;
};
Price.prototype.toString = function () {
  return Price.stringify(Price.numberify(this.value));
};
Price.prototype.toFormat = function () {
  return Price.formatify(Price.numberify(this.value));
};
Price.prototype.toEuro = function () {
  return <span className="nowrap">{Price.formatify(Price.numberify(this.value)) + " EUR"}</span>;
};
Price.prototype.toCurrency = function (unit) {
  return <span className="nowrap">{Price.formatify(Price.numberify(this.value)) + " " + Price.formatUnit(unit)}</span>;
};
Price.prototype.add = function (pPrice) {
  if (pPrice instanceof Price) {
    this.value = this.value + pPrice.get();
  } else {
    throw new Error("invalid argument")
  }
  return this;
};
Price.prototype.subtract = function (pPrice) {
  if (pPrice instanceof Price) {
    this.value = this.value - pPrice.get();
  } else {
    throw new Error("invalid argument")
  }
  return this;
};
Price.prototype.multiAdd = function (pPrice, amount) {
  if (pPrice instanceof Price) {
    this.value = this.value + pPrice.get() * amount;
  } else {
    throw new Error("invalid argument")
  }
  return this;
};
Price.prototype.multiSubtract = function (pPrice, amount) {
  if (pPrice instanceof Price) {
    this.value = this.value - pPrice.get() * amount;
  } else {
    throw new Error("invalid argument")
  }
  return this;
};
Price.prototype.multiply = function (factor) {
  this.value = Price.normalize(this.value * factor);
  return this;
};
Price.prototype.divide = function (factor) {
  this.value = Price.normalize(this.value / factor);
  return this;
};
Price.prototype.addNumber = function (num) {
  this.value = this.value + Price.valueify(num);
  return this;
};
Price.prototype.addTax = function (percentage) {
  this.value = this.value + (this.value / 100) * percentage;
  return this;
};
Price.prototype.subtractNumber = function (num) {
  this.value = this.value - Price.valueify(num);
  return this;
};
Price.prototype.isZero = function () {
  return this.value === 0;
};
Price.prototype.clone = function () {
  return Price.create(0).set(this.value);
};
Price.prototype.abs = function () {
  this.value = Price.absolute(this.value);
  return this;
};

export default Price;
